var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAryaTradeManagerPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.06 134.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a882b4;}.cls-2{fill:#9f7eb1;}.cls-3{fill:#9e7eb0;}.cls-4{fill:#232326;}.cls-5{fill:#fff;}.cls-6{fill:#5f237a;}.cls-7{fill:#37116c;}.cls-8{fill:#5a2178;}.cls-9{fill:#a983b4;}.cls-10{fill:#c3b5d1;}.cls-11{fill:#41166f;}.cls-12{fill:#62257b;}.cls-13{fill:#9d7db0;}.cls-14{fill:#5b2178;}.cls-15{fill:#6e2a7f;}.cls-16{fill:#9b7caf;}.cls-17{fill:#a982b4;}.cls-18{fill:#6b297e;}.cls-19{fill:#551f76;}.cls-20{fill:#592078;}.cls-21{fill:#4d1b74;}.cls-22{fill:#3a136d;}.cls-23{fill:#3f156e;}.cls-24{fill:#c4b5d2;}.cls-25{fill:#431770;}.cls-26{fill:#c5b6d2;}.cls-27{fill:#310e69;}.cls-28{fill:#a17fb1;}.cls-29{fill:#997bae;}.cls-30{fill:#a480b2;}.cls-31{fill:#561f77;}.cls-32{fill:#320f6a;}.cls-33{fill:#300e69;}.cls-34{fill:#a27fb2;}.cls-35{fill:#9a7caf;}.cls-36{fill:#3e146e;}.cls-37{fill:#6c297f;}.cls-38{fill:#c5b5d2;}.cls-39{fill:#35106b;}.cls-40{fill:#c6b6d2;}.cls-41{fill:#68277d;}.cls-42{fill:#9c7caf;}.cls-43{fill:#c3b4d1;}.cls-44{fill:#a681b3;}.cls-45{fill:#471971;}.cls-46{fill:#3b136d;}.cls-47{fill:#64257c;}.cls-48{fill:#a07eb1;}.cls-49{fill:#34106a;}.cls-50{fill:#4e1c74;}.cls-51{fill:#421670;}.cls-52{fill:#441770;}.cls-53{fill:#60247a;}.cls-54{fill:#a380b2;}.cls-55{fill:#39126c;}.cls-56{fill:#6f2b80;}.cls-57{fill:#4f1c74;}.cls-58{fill:#461871;}.cls-59{fill:#511d75;}.cls-60{fill:#9c7daf;}.cls-61{fill:#987bae;}.cls-62{clipPath:url(#clippath);}.cls-63{fill:#38126c;}.cls-64{fill:#3d146e;}.cls-65{fill:none;}.cls-66{fill:#702b80;}.cls-67{fill:#5e2379;}.cls-68{fill:#3c146d;}.cls-69{fill:#4a1a72;}.cls-70{fill:#4c1b73;}.cls-71{fill:#a580b3;}.cls-72{fill:#69287d;}.cls-73{fill:#491a72;}.cls-74{fill:#521d75;}.cls-75{fill:#61247b;}.cls-76{fill:#4b1a73;}.cls-77{fill:#66267c;}.cls-78{fill:#330f6a;}.cls-79{fill:#67277d;}.cls-80{fill:#571f77;}.cls-81{fill:#65267c;}.cls-82{fill:#40156f;}.cls-83{fill:#6a287e;}.cls-84{fill:#531e75;}.cls-85{fill:#c4b5d1;}.cls-86{fill:#63257b;}.cls-87{fill:#a782b4;}.cls-88{fill:#a27fb1;}.cls-89{fill:#541e76;}.cls-90{fill:#36116b;}.cls-91{fill:#a07fb1;}.cls-92{fill:#582077;}.cls-93{fill:#6d2a7f;}.cls-94{fill:#5c2279;}.cls-95{fill:#5d2279;}.cls-96{fill:#481972;}.cls-97{fill:#451871;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M25.91,0H108.76c14.31,0,25.91,11.6,25.91,25.91V108.76c0,14.31-11.6,25.91-25.91,25.91H25.91c-14.31,0-25.91-11.6-25.91-25.91V25.91C0,11.6,11.6,0,25.91,0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.17,77.85h-28.65l-4.11,7.86c-1.5,2.73-2.94,3.76-5.2,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.09-3.42l18.8-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.41,.68,8.27,5.81l18.94,35.56c.62,1.04,.97,2.21,1.02,3.42,0,2.46-2,4.45-4.46,4.44h-.05c-2.26,0-3.76-.96-5.26-3.76l-4.17-7.86Zm-23.93-8.89h19.27l-9.64-18.39-9.63,18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.94,84.68c0,2.64-2.14,4.79-4.79,4.79s-4.79-2.14-4.79-4.79V50.16c0-8.41,2.53-9.23,9.57-9.23h20.51c9.51,0,16.07,5.88,16.07,15.38,.16,6.49-4.08,12.28-10.32,14.08l8.41,10.19c1.3,1.22,2.11,2.87,2.26,4.65-.1,2.43-2.15,4.32-4.58,4.24-1.78,0-3.22-.62-5.26-3.21l-11.42-14.57h-15.66v12.99Zm19.83-34.87h-18.46c-1.37,0-1.37,.69-1.37,2.05v10.94h19.83c5.26,0,7.18-2.6,7.18-6.5s-1.91-6.5-7.18-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.61,84.68c.02,2.64-2.11,4.8-4.75,4.82-2.64,.02-4.8-2.11-4.82-4.75v-16.47l-21.33-19.69c-1-.91-1.6-2.2-1.64-3.55-.13-2.52,1.81-4.66,4.33-4.79,.17,0,.34,0,.52,0,1.35,.03,2.62,.6,3.55,1.57l19.35,17.98,19.35-17.98c.93-.97,2.21-1.54,3.56-1.57,2.52-.16,4.69,1.75,4.85,4.27,.01,.17,.01,.34,0,.52-.05,1.36-.64,2.64-1.64,3.55l-21.33,19.69v16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M397.11,77.85h-28.65l-4.11,7.86c-1.5,2.73-2.94,3.76-5.19,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.09-3.42l18.81-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.4,.68,8.27,5.81l18.94,35.56c.62,1.03,.98,2.21,1.03,3.42,0,2.46-2,4.45-4.45,4.44h-.06c-2.26,0-3.76-.96-5.27-3.76l-4.17-7.86Zm-23.93-8.89h19.28l-9.64-18.39-9.64,18.39Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "249.47 106.69 258.17 106.69 258.17 107.79 254.5 107.79 254.5 119.94 253.17 119.94 253.17 107.79 249.47 107.79 249.47 106.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M261.62,119.94h-1.33v-10.35h1.33v1.84c.57-1.27,1.76-2.03,3.54-2.03v1.38h-.36c-1.72,0-3.18,.78-3.18,3.37v5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M271.51,109.44c2.08,0,3.51,1.12,4.09,2.43v-2.28h1.33v10.35h-1.33v-2.29c-.61,1.33-2.05,2.45-4.11,2.45-2.82,0-4.93-2.1-4.93-5.34s2.1-5.31,4.95-5.31Zm.25,1.16c-2.18,0-3.85,1.52-3.85,4.15s1.67,4.19,3.85,4.19,3.85-1.59,3.85-4.17-1.72-4.17-3.85-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M284.34,109.44c1.86,0,3.41,1.02,4.07,2.39v-5.91h1.33v14.02h-1.33v-2.31c-.61,1.37-2.05,2.46-4.09,2.46-2.84,0-4.95-2.1-4.95-5.34s2.1-5.31,4.97-5.31Zm.23,1.16c-2.18,0-3.85,1.52-3.85,4.15s1.67,4.19,3.85,4.19,3.85-1.59,3.85-4.17-1.72-4.17-3.85-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M297.27,120.09c-2.94,0-5.08-2.05-5.08-5.33s2.1-5.32,5.08-5.32,4.89,2.16,4.89,4.79c0,.42,0,.68-.04,1.04h-8.58c.11,2.43,1.8,3.7,3.73,3.7,1.76,0,2.96-.93,3.34-2.31h1.4c-.47,1.95-2.14,3.43-4.74,3.43Zm-3.73-5.89h7.28c.06-2.41-1.69-3.62-3.6-3.62s-3.52,1.21-3.68,3.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "309.82 106.86 311.22 106.86 316.28 118.2 321.34 106.86 322.76 106.86 322.76 119.94 321.43 119.94 321.43 109.5 316.77 119.94 315.8 119.94 311.14 109.54 311.14 119.94 309.82 119.94 309.82 106.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M330.13,109.44c2.08,0,3.51,1.12,4.09,2.43v-2.28h1.33v10.35h-1.33v-2.29c-.61,1.33-2.05,2.45-4.11,2.45-2.82,0-4.93-2.1-4.93-5.34s2.1-5.31,4.95-5.31Zm.25,1.16c-2.18,0-3.85,1.52-3.85,4.15s1.67,4.19,3.85,4.19,3.85-1.59,3.85-4.17-1.72-4.17-3.85-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M346.36,114.03c0-2.29-1.25-3.47-3.15-3.47s-3.28,1.21-3.28,3.73v5.65h-1.33v-10.35h1.33v1.76c.66-1.29,1.99-1.95,3.52-1.95,2.35,0,4.21,1.44,4.21,4.47v6.06h-1.31v-5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M354.96,109.44c2.08,0,3.51,1.12,4.09,2.43v-2.28h1.33v10.35h-1.33v-2.29c-.61,1.33-2.05,2.45-4.11,2.45-2.82,0-4.93-2.1-4.93-5.34s2.1-5.31,4.95-5.31Zm.25,1.16c-2.18,0-3.85,1.52-3.85,4.15s1.67,4.19,3.85,4.19,3.85-1.59,3.85-4.17-1.72-4.17-3.85-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M367.77,109.44c2.05,0,3.51,1.1,4.09,2.41v-2.26h1.33v10.61c0,2.9-1.99,4.81-4.83,4.81-2.67,0-4.53-1.37-4.95-3.53h1.31c.44,1.4,1.74,2.37,3.64,2.37s3.51-1.31,3.51-3.66v-2.56c-.61,1.33-2.05,2.45-4.09,2.45-2.84,0-4.95-2.1-4.95-5.34s2.1-5.31,4.95-5.31Zm.25,1.16c-2.18,0-3.85,1.52-3.85,4.15s1.67,4.19,3.85,4.19,3.85-1.59,3.85-4.17-1.72-4.17-3.85-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M380.71,120.09c-2.94,0-5.08-2.05-5.08-5.33s2.1-5.32,5.08-5.32,4.89,2.16,4.89,4.79c0,.42,0,.68-.04,1.04h-8.58c.11,2.43,1.8,3.7,3.73,3.7,1.76,0,2.96-.93,3.34-2.31h1.4c-.47,1.95-2.14,3.43-4.74,3.43Zm-3.73-5.89h7.28c.06-2.41-1.69-3.62-3.6-3.62s-3.52,1.21-3.68,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M389.38,119.94h-1.33v-10.35h1.33v1.84c.57-1.27,1.76-2.03,3.54-2.03v1.38h-.36c-1.72,0-3.18,.78-3.18,3.37v5.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "405.45 108.1 405.45 112.36 409.67 112.36 409.67 113.5 405.45 113.5 405.45 117.76 404.21 117.76 404.21 113.5 400.01 113.5 400.01 112.36 404.21 112.36 404.21 108.1 405.45 108.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "15.18 0 0 15.18 0 0 15.18 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "58.22 0 0 58.22 0 15.18 15.18 0 58.22 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "60.62 0 0 60.62 0 58.22 58.22 0 60.62 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "63.02 0 0 63.02 0 60.62 60.62 0 63.02 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "65.42 0 0 65.42 0 63.02 63.02 0 65.42 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "67.82 0 0 67.82 0 65.42 65.42 0 67.82 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "70.22 0 0 70.22 0 67.82 67.82 0 70.22 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "72.62 0 0 72.62 0 70.22 70.22 0 72.62 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-83",
    points: "75.02 0 0 75.02 0 72.62 72.62 0 75.02 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-72",
    points: "77.42 0 0 77.42 0 75.02 75.02 0 77.42 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "79.82 0 0 79.82 0 77.42 77.42 0 79.82 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-79",
    points: "82.22 0 0 82.22 0 79.82 79.82 0 82.22 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-77",
    points: "84.62 0 0 84.62 0 82.22 82.22 0 84.62 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-81",
    points: "87.02 0 0 87.02 0 84.62 84.62 0 87.02 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "89.43 0 0 89.42 0 87.02 87.02 0 89.43 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-86",
    points: "91.83 0 0 91.83 0 89.42 89.43 0 91.83 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "94.23 0 0 94.23 0 91.83 91.83 0 94.23 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-75",
    points: "96.63 0 0 96.63 0 94.23 94.23 0 96.63 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-53",
    points: "99.03 0 0 99.03 0 96.63 96.63 0 99.03 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "101.43 0 0 101.43 0 99.03 99.03 0 101.43 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-67",
    points: "103.83 0 0 103.83 0 101.43 101.43 0 103.83 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-95",
    points: "106.23 0 0 106.23 0 103.83 103.83 0 106.23 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-94",
    points: "108.63 0 0 108.63 0 106.23 106.23 0 108.63 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "111.03 0 0 111.03 0 108.63 108.63 0 111.03 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "113.43 0 0 113.43 0 111.03 111.03 0 113.43 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "115.83 0 0 115.83 0 113.43 113.43 0 115.83 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-92",
    points: "118.23 0 0 118.23 0 115.83 115.83 0 118.23 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-80",
    points: "120.63 0 0 120.63 0 118.23 118.23 0 120.63 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "123.03 0 0 123.03 0 120.63 120.63 0 123.03 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "125.44 0 0 125.44 0 123.03 123.03 0 125.44 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-89",
    points: "125.9 0 126.87 .97 .97 126.87 0 125.9 0 125.44 125.44 0 125.9 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-84",
    points: ".97 126.87 2.17 128.07 128.07 2.17 126.87 .97 .97 126.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-74",
    points: "2.17 128.07 3.37 129.27 129.27 3.37 128.07 2.17 2.17 128.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-59",
    points: "3.37 129.27 4.57 130.47 130.47 4.57 129.27 3.37 3.37 129.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-57",
    points: "4.57 130.47 5.77 131.67 131.67 5.77 130.47 4.57 4.57 130.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-50",
    points: "5.77 131.67 6.97 132.87 132.87 6.97 131.67 5.77 5.77 131.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "6.97 132.87 8.17 134.07 134.07 8.17 132.87 6.97 6.97 132.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-70",
    points: "134.07 8.17 134.67 8.77 134.67 9.97 9.97 134.67 8.77 134.67 8.17 134.07 134.07 8.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-76",
    points: "134.67 12.37 12.37 134.67 9.97 134.67 134.67 9.97 134.67 12.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-69",
    points: "134.67 14.77 14.77 134.67 12.37 134.67 134.67 12.37 134.67 14.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-73",
    points: "134.67 17.17 17.17 134.67 14.77 134.67 134.67 14.77 134.67 17.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96",
    points: "134.67 19.57 19.57 134.67 17.17 134.67 134.67 17.17 134.67 19.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "134.67 21.97 21.98 134.67 19.57 134.67 134.67 19.57 134.67 21.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-58",
    points: "134.67 24.37 24.38 134.67 21.98 134.67 134.67 21.97 134.67 24.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-97",
    points: "134.67 26.78 26.78 134.67 24.38 134.67 134.67 24.37 134.67 26.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-52",
    points: "134.67 29.18 29.18 134.67 26.78 134.67 134.67 26.78 134.67 29.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "134.67 31.58 31.58 134.67 29.18 134.67 134.67 29.18 134.67 31.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "134.67 33.98 33.98 134.67 31.58 134.67 134.67 31.58 134.67 33.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "134.67 36.38 36.38 134.67 33.98 134.67 134.67 33.98 134.67 36.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "134.67 38.78 38.78 134.67 36.38 134.67 134.67 36.38 134.67 38.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "134.67 41.18 41.18 134.67 38.78 134.67 134.67 38.78 134.67 41.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "134.67 43.58 43.58 134.67 41.18 134.67 134.67 41.18 134.67 43.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "134.67 45.98 45.98 134.67 43.58 134.67 134.67 43.58 134.67 45.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "134.67 48.38 48.38 134.67 45.98 134.67 134.67 45.98 134.67 48.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "134.67 50.78 50.78 134.67 48.38 134.67 134.67 48.38 134.67 50.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "134.67 53.18 53.18 134.67 50.78 134.67 134.67 50.78 134.67 53.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "134.67 55.58 55.58 134.67 53.18 134.67 134.67 53.18 134.67 55.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "134.67 57.99 57.99 134.67 55.58 134.67 134.67 55.58 134.67 57.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "134.67 60.39 60.39 134.67 57.99 134.67 134.67 57.99 134.67 60.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "134.67 62.79 62.79 134.67 60.39 134.67 134.67 60.39 134.67 62.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "134.67 65.19 65.19 134.67 62.79 134.67 134.67 62.79 134.67 65.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "134.67 67.59 67.59 134.67 65.19 134.67 134.67 65.19 134.67 67.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "134.67 69.99 69.99 134.67 67.59 134.67 134.67 67.59 134.67 69.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "134.67 72.39 72.39 134.67 69.99 134.67 134.67 69.99 134.67 72.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "134.67 74.79 74.79 134.67 72.39 134.67 134.67 72.39 134.67 74.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "134.67 77.19 77.19 134.67 74.79 134.67 134.67 74.79 134.67 77.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "134.67 119.49 119.49 134.67 77.19 134.67 134.67 77.19 134.67 119.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "119.49 134.67 134.67 119.49 134.67 134.67 119.49 134.67"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "69.35 70.49 40.19 99.54 40.41 99.43 69.35 70.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "72.52 67.34 69.35 70.49 40.41 99.43 45.28 96.96 73.74 68.5 72.52 67.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "73.74 68.5 45.28 96.96 50.15 94.49 74.97 69.67 73.74 68.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "74.97 69.67 50.15 94.49 55.02 92.02 76.19 70.85 74.97 69.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "76.19 70.85 55.02 92.02 59.9 89.55 77.42 72.02 76.19 70.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "77.42 72.02 59.9 89.55 64.77 87.07 78.65 73.19 77.42 72.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "78.65 73.19 64.77 87.07 69.64 84.6 79.88 74.36 78.65 73.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-85",
    points: "79.88 74.36 69.64 84.6 74.51 82.13 81.11 75.54 79.88 74.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-85",
    points: "81.11 75.54 74.51 82.13 79.39 79.66 82.34 76.71 81.11 75.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "82.34 76.71 79.39 79.66 83.33 77.66 82.34 76.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "72.62 67 72.4 67 39.23 100.05 39.19 100.16 39.35 100.32 39.42 100.3 39.67 100.17 40.41 99.43 40.19 99.54 69.35 70.49 72.73 67.11 72.62 67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M45.28,96.96l-4.87,2.47-.74,.74,4.87-2.47,.74-.74m27.46-29.86l-3.38,3.38,3.16-3.15,1.22,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.15,94.49l-4.87,2.47-.74,.74,4.87-2.47,.74-.74m23.81-26.21l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M55.02,92.02l-4.87,2.47-.74,.74,4.87-2.47,.75-.75m20.17-22.57l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M59.9,89.55l-4.87,2.47-.75,.75,4.87-2.47,.75-.75m16.52-18.92l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M64.77,87.07l-4.87,2.47-.75,.75,4.87-2.47,.75-.75m12.88-15.28l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M69.64,84.6l-4.87,2.47-.75,.75,4.87-2.47,.75-.75m9.23-11.63l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M74.51,82.13l-4.87,2.47-.75,.75,4.87-2.47,.76-.76m5.59-7.99l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M79.39,79.66l-4.87,2.47-.76,.76,4.87-2.47,.76-.76m1.94-4.34l-.22,.22,1.23,1.17,.22-.22-1.23-1.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "82.56 76.49 82.34 76.71 83.33 77.66 79.39 79.66 78.63 80.42 83.5 77.94 83.75 77.69 83.72 77.59 82.56 76.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "83.75 77.69 83.5 77.94 83.68 77.85 83.77 77.73 83.75 77.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "37.37 33.78 37.37 35.25 38.12 34.5 37.37 33.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "38.12 34.5 37.37 35.25 37.37 37.65 39.35 35.67 38.12 34.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.35 35.67 37.37 37.65 37.37 40.05 40.58 36.85 39.35 35.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-87",
    points: "40.58 36.85 37.37 40.05 37.37 42.46 41.8 38.02 40.58 36.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-87",
    points: "41.8 38.02 37.37 42.46 37.37 44.86 43.03 39.19 41.8 38.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "43.03 39.19 37.37 44.86 37.37 47.26 44.26 40.36 43.03 39.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "44.26 40.36 37.37 47.26 37.37 49.66 45.49 41.54 44.26 40.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-71",
    points: "45.49 41.54 37.37 49.66 37.37 52.06 46.72 42.71 45.49 41.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "46.72 42.71 37.37 52.06 37.37 54.46 47.94 43.88 46.72 42.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "47.94 43.88 37.37 54.46 37.37 56.86 49.17 45.05 47.94 43.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-54",
    points: "49.17 45.05 37.37 56.86 37.37 59.26 50.4 46.23 49.17 45.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-54",
    points: "50.4 46.23 37.37 59.26 37.37 61.66 51.63 47.4 50.4 46.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "51.63 47.4 37.37 61.66 37.37 64.06 52.86 48.57 51.63 47.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-88",
    points: "52.86 48.57 37.37 64.06 37.37 66.46 54.09 49.74 52.86 48.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "54.09 49.74 37.37 66.46 37.37 68.86 55.31 50.92 54.09 49.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-91",
    points: "55.31 50.92 37.37 68.86 37.37 71.26 56.54 52.09 55.31 50.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-48",
    points: "56.54 52.09 37.37 71.26 37.37 73.66 57.77 53.26 56.54 52.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "57.77 53.26 37.37 73.66 37.37 76.07 59 54.43 57.77 53.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "59 54.43 37.37 76.07 37.37 78.47 60.23 55.61 59 54.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "60.23 55.61 37.37 78.47 37.37 80.87 61.46 56.78 60.23 55.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "61.46 56.78 37.37 80.87 37.37 83.27 62.68 57.95 61.46 56.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "62.68 57.95 37.37 83.27 37.37 85.67 63.91 59.12 62.68 57.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-60",
    points: "63.91 59.12 37.37 85.67 37.37 88.07 65.14 60.3 63.91 59.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "65.14 60.3 37.37 88.07 37.37 90.47 66.37 61.47 65.14 60.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "66.37 61.47 37.37 90.47 37.37 92.87 67.6 62.64 66.37 61.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "67.6 62.64 37.37 92.87 37.37 95.27 68.82 63.81 67.6 62.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "68.82 63.81 37.37 95.27 37.37 97.67 70.05 64.99 68.82 63.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "70.05 64.99 37.37 97.67 37.37 99.89 71.25 66.13 70.05 64.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.2,33.24c-.09,0-.16,.07-.16,.16v2.18l.33-.33v-1.47l.75,.72,.23-.23-1.03-.99-.11-.04h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M37.37,35.25l-.33,.33v2.4l.33-.33v-2.4m.98-.98l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.37,37.65l-.33,.33v2.4l.33-.33v-2.4m2.21-2.21l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M37.37,40.05l-.33,.33v2.4l.33-.33v-2.4m3.44-3.44l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M37.37,42.46l-.33,.33v2.4l.33-.33v-2.4m4.67-4.67l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M37.37,44.86l-.33,.33v2.4l.33-.33v-2.4m5.89-5.89l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M37.37,47.26l-.33,.33v2.4l.33-.33v-2.4m7.12-7.12l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M37.37,49.66l-.33,.33v2.4l.33-.33v-2.4m8.35-8.35l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M37.37,52.06l-.33,.33v2.4l.33-.33v-2.4m9.58-9.58l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M37.37,54.46l-.33,.33v2.4l.33-.33v-2.4m10.81-10.81l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M37.37,56.86l-.33,.33v2.4l.33-.33v-2.4m12.04-12.04l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M37.37,59.26l-.33,.33v2.4l.33-.33v-2.4m13.26-13.26l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M37.37,61.66l-.33,.33v2.4l.33-.33v-2.4m14.49-14.49l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M37.37,64.06l-.33,.33v2.4l.33-.33v-2.4m15.72-15.72l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M37.37,66.46l-.33,.33v2.4l.33-.33v-2.4m16.95-16.95l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M37.37,68.86l-.33,.33v2.4l.33-.33v-2.4m18.18-18.18l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M37.37,71.26l-.33,.33v2.4l.33-.33v-2.4m19.4-19.41l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.37,73.66l-.33,.33v2.4l.33-.33v-2.4m20.63-20.63l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.37,76.07l-.33,.33v2.4l.33-.33v-2.4m21.86-21.86l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.37,78.47l-.33,.33v2.4l.33-.33v-2.4m23.09-23.09l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.37,80.87l-.33,.33v2.4l.33-.33v-2.4m24.32-24.32l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.37,83.27l-.33,.33v2.4l.33-.33v-2.4m25.55-25.55l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M37.37,85.67l-.33,.33v2.4l.33-.33v-2.4m26.77-26.77l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M37.37,88.07l-.33,.33v2.4l.33-.33v-2.4m28-28l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M37.37,90.47l-.33,.33v2.4l.33-.33v-2.4m29.23-29.23l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M37.37,92.87l-.33,.33v2.4l.33-.33v-2.4m30.46-30.46l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M37.37,95.27l-.33,.33v2.4l.33-.33v-2.4m31.69-31.69l-.23,.23,1.23,1.17,.23-.23-1.23-1.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "70.28 64.76 70.05 64.99 71.25 66.13 37.37 99.89 37.37 97.67 37.04 98 37.04 100.28 37.09 100.35 71.51 65.93 70.28 64.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-61",
    points: "71.51 65.93 37.09 100.35 37.14 100.43 37.2 100.44 37.33 100.39 71.6 66.24 71.65 66.12 71.59 66.01 71.51 65.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "38.99 33.14 84.95 77.01 105.21 66.74 38.99 33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.95,77.18l-.11-.05L38.87,33.25v-.23l.18-.03,66.23,33.6,.07,.22-.07,.07-20.26,10.28-.08,.02ZM39.89,33.78l45.09,43.04,19.87-10.08L39.89,33.78Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAryaTradeManagerPlus);
export default __webpack_public_path__ + "static/media/arya-trade-manager-plus.3c3289301dbd883cef3c25628c65c93c.svg";
export { ForwardRef as ReactComponent };